import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HelmetTitle = ({ title }) => {
  const location = useLocation();

  // Generate dynamic title based on route if no specific title provided
  const getDefaultTitle = () => {
    const path = location.pathname;

    if (path === "/") return "الرئيسية";
    if (path.includes("/products")) return "المنتجات";
    if (path.includes("/product")) return "تفاصيل المنتج";
    if (path.includes("/categories")) return "الفئات";
    if (path.includes("/category")) return "تفاصيل الفئة";
    if (path.includes("/blog")) return "المدونة";
    if (path.includes("/cart")) return "سلة التسوق";
    if (path.includes("/wishlist")) return "المفضلة";
    if (path.includes("/about")) return "من نحن";
    if (path.includes("/contact")) return "اتصل بنا";
    if (path.includes("/request")) return "طلب بيع";
    if (path.includes("/sales")) return "العروض";
    if (path.includes("/login")) return "تسجيل الدخول";
    if (path.includes("/admin")) return "لوحة التحكم";

    return "متجر بروتاكتا للسلامة";
  };

  const finalTitle = title || getDefaultTitle();
  const fullTitle = `${finalTitle} | متجر بروتاكتا للسلامة`;

  // Log for debugging - remove in production
  useEffect(() => {}, [fullTitle, location.pathname]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta property="og:title" content={fullTitle} />
      <meta name="twitter:title" content={fullTitle} />
      <meta property="og:url" content={window.location.href} />
      <link rel="canonical" href={window.location.href} />
    </Helmet>
  );
};

export default HelmetTitle;
